import { Navigate } from "react-router-dom";
import { getAccessToken, getCurrentUser } from "../utils/auth/tokenStore";
import { roleRouteMap } from "../constants/options";

const PublicRouteGuard = ({ children }) => {
    const token = getAccessToken();
    if (!token) {
        return children; // not logged in → show public page (login)
    }
    const user = getCurrentUser();
    if (!user || !user.role) {
        return children;
    }
    const route = roleRouteMap[user.role];
    if (!route) {
        return <Navigate to="/" replace />;
    }
    return <Navigate to={route} replace />;
};

export default PublicRouteGuard;